import "./BusinessLitigation.module.css";
import Footer from "@/reusable_sections/Footer";
import Herobusinesslitigation from "./sections/Herobusinesslitigation";
import BusinessMattersOverview from "./sections/BusinessMattersOverview";
import Businessdisputeslist from "./sections/Businessdisputeslist";
import Corporategovernancegrid from "./sections/Corporategovernancegrid";
import Theapproach from "./sections/Theapproach";
import Nextstepbusinessmatter from "./sections/Nextstepbusinessmatter";
export default function BusinessLitigationPage() {
  return <div>
      <Herobusinesslitigation />
      <BusinessMattersOverview />
      <Businessdisputeslist />
      <Corporategovernancegrid />
      <Theapproach />
      <Nextstepbusinessmatter />
      <Footer />
    </div>;
}